import ParityFilterInput from '@app/model/parity/input/ParityFilterInput';
import { GraphQLExecutor } from '@app/model/_common/service/GraphQLExecutor';
import {
	FIND_OTA_PRICES_FOR_MONTH,
	FIND_OTA_PRICES_FOR_PERIOD,
	FIND_PARITY_FOR_MONTH,
	FIND_PARITY_FOR_PERIOD,
} from '@app/model/parity/service/ParityGraphQLQueries';
import ParitySnapshot from '@app/model/parity/ParitySnapshot';
import month from '@app/model/market_state/Month';
import { OtaPriceStateSnapshot } from '@app/model/parity/OtaPriceStateSnapshot';

class ParityService {

	public static findParityForMonth(hotelId: number, year: number, month: month, filterInput: ParityFilterInput) {
		return GraphQLExecutor.execute<ParitySnapshot>(FIND_PARITY_FOR_MONTH, {
			hotelId: hotelId,
			year: year,
			month: month,
			filterInput: filterInput,
		});
	}

	public static findParityForPeriod(companyHotelId: number, startStatDate: string, endStatDate: string, filterInput: ParityFilterInput) {
		return GraphQLExecutor.execute<ParitySnapshot>(FIND_PARITY_FOR_PERIOD, {
			companyHotelId: companyHotelId,
			startStatDate: startStatDate,
			endStatDate: endStatDate,
			filterInput: filterInput,
		});
	}

	public static findOtaPricesForMonth(companyHotelId: number, year: number, month: month, filterInput: ParityFilterInput) {
		return GraphQLExecutor.execute<OtaPriceStateSnapshot>(FIND_OTA_PRICES_FOR_MONTH, {
			companyHotelId: companyHotelId,
			year: year,
			month: month,
			filterInput: filterInput,
		});
	}

	public static findOtaPricesForPeriod(companyHotelId: number, startStatDate: string, endStatDate: string, filterInput: ParityFilterInput) {
		return GraphQLExecutor.execute<OtaPriceStateSnapshot>(FIND_OTA_PRICES_FOR_PERIOD, {
			companyHotelId: companyHotelId,
			startStatDate: startStatDate,
			endStatDate: endStatDate,
			filterInput: filterInput,
		});
	}
}

export default ParityService;